<template>
  <div class="xqNews_detail gw_detail">
    <!-- 顾问团队详情 -->
    <!-- 内容区 -->
    <div class="content">
      <div class="infoCon inner clearfix">
        <!-- 面包屑导航 -->
        <div class="mbnav">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
              <img class="homeIcon" src="/statics/image/index/home.png" alt />
              首页
            </el-breadcrumb-item>
            <!-- :to="{ path: '/xqNews' }" -->
            <el-breadcrumb-item>
              <span @click="toback">领导信息</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>顾问团队</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="title">
          <h3>{{articledetail.article_info.title}}</h3>
          <div class="desc">
            <span>发布时间:{{articledetail.article_info.publish_at}}</span>
            <span>发布人:{{articledetail.article_info.admin.realname}}</span>
            <span>点击次数:{{articledetail.article_info.hits}}</span>
          </div>
        </div>
        <!-- 新闻内容 -->
        <div class="newscom">
          <div class="fwb" v-html="content"></div>
          <a
            :href="$url+articledetail.article_info.fujian"
            class="fujian"
            v-if="articledetail.article_info.fujian"
          >附件：{{articledetail.article_info.fujian_name}}</a>
        </div>
        <!-- 打印 -->
        <!-- <div class="yin f-r">
        <img src="/statics/image/index/home.png" alt />
          <span>打印此页</span>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: "", //富文本
      articledetail: {
        article_info: {
          admin: {}
        },
        last_article: {}, //上一篇
        next_article: {} //下一篇
      }
    };
  },
  created() {
    this.getArticledetail();
  },
  methods: {
    toback() {
      this.$router.go(-1);
    },
    getArticledetail() {
      var that = this;
      var ps = {
        article_id: that.$route.query.id
      };
      that.$api.index.articledetail(ps).then(function(res) {
        if (res.code == 200) {
          that.articledetail = res.result;
          that.content = res.result.article_info.content.replace(
            /\ src\=\"\upload/g,
            ' class="fupic" src="' + that.$url + "/upload"
          );
        }
      });
    }
  }
};
</script>

<style>
</style>